import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import {
  BannerSection,
  BenefitsSection,
  CtaSection,
  HeroSection,
  PromoSection,
  SmallPrintSection,
} from '../sections';
import { LandingVariantProps } from './types';

/**
 * Variant C — online only: the external registration link promoted to the
 * primary CTA, no phone number. Placeholder layout until the final UX
 * designs arrive; LandingPage guarantees this variant is never rendered when
 * the online link is suppressed for the visitor's locale.
 */
export const LinkOnly: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => (
  <div className="grid grid-cols-12">
    <BannerSection text={copy.banner} />
    <HeroSection number={data.heroNumber} copy={copy.heroCopy} />
    <PromoSection subCopy1={copy.heroSubCopy1} subCopy2={copy.heroSubCopy2} />
    <CtaSection title={copy.registration}>
      <p className="text-body">{copy.onlineCopy}</p>
      <div className="w-full md:w-fit">
        <ButtonLink
          href={data.ctaOnlineLink}
          variant="primary"
          id="online-link-cta"
          onClick={() => onCtaClick('online', data.ctaOnlineLink)}
        >
          {copy.ctaOnlineText}
        </ButtonLink>
      </div>
    </CtaSection>
    <BenefitsSection header={data.benefitsHeader} benefits={data.benefits} />
    <SmallPrintSection
      data={{
        ...data,
        phoneNumberAsterix: copy.phoneNumberAsterix,
        phoneNumberAsterixLinks: copy.phoneNumberAsterixLinks,
      }}
    />
  </div>
);
